export default __webpack_public_path__ + "static/media/image-1.63bb4968.png";